module.exports = __webpack_public_path__ + "img/default_user.9945d751.png";